import PropTypes from "prop-types";
import { useToast } from "./ToastProvider";
import Toast from "./Toast";

const ToastContainer = ({ dataTestId = "toast-container" }) => {
  const { toasts, removeToast } = useToast();
  return (
    <div
      data-testid={dataTestId}
      className="fixed z-[9999] w-screen max-h-screen overflow-y-hidden flex flex-col items-center gap-y-2.5 pt-10 pointer-events-none"
    >
      {toasts.map(({ id, message, type, dataTestId, autoClose, className, preventCloseOnHover, preventAutoClose }) => (
        <div key={id} className="pointer-events-auto w-11/12 h-20">
          <Toast
            key={id}
            id={id}
            message={message}
            type={type}
            dataTestId={dataTestId}
            autoClose={autoClose}
            onClose={removeToast}
            className={className}
            preventCloseOnHover={preventCloseOnHover}
            preventAutoClose={preventAutoClose}
          />
        </div>
      ))}
    </div>
  );
};

ToastContainer.propTypes = {
  dataTestId: PropTypes.string,
};

export default ToastContainer;
